export default "__VITE_ASSET__BkBzQm5l__"